import React, { useContext } from 'react';
import theme from '../theme/theme';
import { calcCompletion, getMatchDetails } from '../utils'
import { Avatar, Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import { globalStore } from '../state/store';
import { useNavigate } from "react-router-dom";
import { BottomNav, CircularProgressCP, CompleteAccount, DisplayMatchScore, Header,
         LeagueManager, RankedList } from '../components';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { predictionReview } from '../services/predictionService'

function Dashboard() {

  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));

  const styles = {
    dashbox: {
      width: isLgUp ? '90%' : isMdUp ? '94%' : isSmUp ? '98%' : '100%', 
      backgroundColor: theme.palette.primary.contrastText, 
      borderRadius: '20px'
    }
  }

  const [state] = useContext(globalStore);
  const [loading, setLoading] = React.useState(false);
  const [reviewResponse, setReviewResponse] = React.useState(null)

  const dayjs = require('dayjs')
  const navigate = useNavigate();

  const handleReviewAnswers = () => {
    setLoading(true)
    predictionReview()
    .then((pr) => {
      setReviewResponse({success: true, msg: pr })
      setLoading(false);
    }).catch((err) => {
      setReviewResponse({success: false, msg: err })
      setLoading(false);
    })
  }

  return (
    <div style={{height: '100vh'}}>

      <Header page={"Dashboard"} />
      <BottomNav page={"Dashboard"} />

      <Box sx={{mt: isMdUp ? 8 : 0, pt: isMdUp ? 6 : 4, minHeight: '100vh', backgroundColor: theme.palette.grey[200]}}>
        {!Boolean(state.user) || !Boolean(state.user.email) ?
        "Not logged in"
        :
        !Boolean(state.user.displayName) || !Boolean(state.user.nickName) ?
        // Complete Setup
        <CompleteAccount />
        :
        <Grid container direction="column" justifyContent="center" alignItems="center"
        sx={{width: '100%', pt: 2, pb: 5, mt:0, px: isSmUp ? 4 : 3}}>

          <Grid item xs={12} container direction="row" justifyContent="center" alignItems="flex-start">

            <Grid item xs={12} md={6} container justifyContent="center" alignItems="center">
              <Box sx={styles.dashbox}>

                <Typography align='center' variant="h5" sx={{my: 3, mx: 2}}>Your Prediction</Typography>
                
                <Grid container direction="row" spacing={2} sx={{px: 3, pb: 3}}>
                  <Grid item xs={4} sx={{mb: 1}}>
                    <Grid container direction="column" alignItems={"center"}>
                      <Grid item xs={12}>
                      <CircularProgressbar
                      background
                      backgroundPadding={8}
                      value={calcCompletion("weuro2025", "group", state.prediction, state.matches)} 
                      text={`${calcCompletion("weuro2025", "group", state.prediction, state.matches)}%`} 
                      styles={buildStyles({
                        /*trailColor: theme.palette.grey[200],
                        pathColor: calcCompletion("weuro2025", "group", state.prediction, state.matches) === 100 ? 
                          theme.palette.success.main : 
                          theme.palette.primary.main,
                        textColor: theme.palette.grey[900],
                        backgroundColor: theme.palette.grey[100]*/
                        //trailColor: theme.palette.primary.contrastText,
                        trailColor: theme.palette.primary.light,
                        pathColor: theme.palette.primary.contrastText,
                        textColor: theme.palette.primary.contrastText,
                        backgroundColor: calcCompletion("weuro2025", "group", state.prediction, state.matches) === 100 ? 
                          theme.palette.success.main : 
                          theme.palette.primary.main
                      })}
                      />
                      </Grid>
                      <Grid item xs={12}>
                        <Button 
                        color={calcCompletion("weuro2025", "group", state.prediction, state.matches) === 100 ?
                          'success' : 'primary'}
                        variant="contained" sx={{width: isSmUp ? '120px' : '80px', 
                        marginTop: '15px', fontWeight: isSmUp ? '700' : '600', 
                        color: theme.palette.primary.contrastText,
                        fontSize: isSmUp ? '14px' : '12px'}}
                        onClick={e => navigate("/predict/groups")}>
                          Group&nbsp;<FontAwesomeIcon icon={faArrowRight} style={{display: isSmUp ? 'block' : 'none'}}  />
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={4} sx={{mb: 1}}>
                    <Grid container direction="column" alignItems={"center"}>
                      <Grid item xs={12}>
                      <CircularProgressbar
                      background
                      backgroundPadding={8}
                      value={calcCompletion("weuro2025", "knockout", state.prediction, state.matches)} 
                      text={`${calcCompletion("weuro2025", "knockout", state.prediction, state.matches)}%`} 
                      styles={buildStyles({
                        trailColor: theme.palette.primary.light,
                        pathColor: theme.palette.primary.contrastText,
                        textColor: theme.palette.primary.contrastText,
                        backgroundColor: calcCompletion("weuro2025", "knockout", state.prediction, state.matches) === 100 ? 
                          theme.palette.success.main : 
                          theme.palette.primary.main/*
                        trailColor: theme.palette.grey[200],
                        pathColor: calcCompletion("weuro2025", "knockout", state.prediction, state.matches) === 100 ? 
                          theme.palette.success.main : 
                          theme.palette.primary.main,
                        textColor: theme.palette.grey[900],
                        backgroundColor: theme.palette.grey[100],*/
                      })}
                      />
                      </Grid>
                      <Grid item xs={12}>
                        <Button 
                        color={calcCompletion("weuro2025", "knockout", state.prediction, state.matches) === 100 ?
                          'success' : 'primary'}
                        variant="contained" sx={{width: isSmUp ? '120px' : '80px', 
                        marginTop: '15px', fontWeight: isSmUp ? '700' : '600', 
                        color: theme.palette.primary.contrastText,
                        fontSize: isSmUp ? '14px' : '12px'}}
                        onClick={e => navigate("/predict/knockout")}>
                          Knockout&nbsp;<FontAwesomeIcon icon={faArrowRight} style={{display: isSmUp ? 'block' : 'none'}}  />
                        </Button>
                      </Grid>
                    </Grid>

                  </Grid>

                  <Grid item xs={4} sx={{mb: 1}}>
                    <Grid container direction="column" alignItems={"center"}>
                      <Grid item xs={12}>
                      <CircularProgressbar
                      background
                      backgroundPadding={8}
                      value={calcCompletion("weuro2025", "questionnaire", state.prediction, state.questions)} 
                      text={`${calcCompletion("weuro2025", "questionnaire", state.prediction, state.questions)}%`} 
                      styles={buildStyles({
                        trailColor: theme.palette.primary.light,
                        pathColor: theme.palette.primary.contrastText,
                        textColor: theme.palette.primary.contrastText,
                        backgroundColor: calcCompletion("weuro2025", "questionnaire", state.prediction, state.questions) === 100 ? 
                          theme.palette.success.main : 
                          theme.palette.primary.main/*
                        trailColor: theme.palette.grey[200],
                        pathColor: calcCompletion("weuro2025", "questionnaire", state.prediction, state.questions) === 100 ? 
                          theme.palette.success.main : 
                          theme.palette.primary.main,
                        textColor: theme.palette.grey[900],
                        backgroundColor: theme.palette.grey[100]*/
                      })}
                      />
                      </Grid>
                      <Grid item xs={12}>
                        <Button 
                        color={calcCompletion("weuro2025", "questionnaire", state.prediction, state.questions) === 100 ?
                          'success' : 'primary'}
                        variant="contained" sx={{width: isSmUp ? '120px' : '80px', 
                        marginTop: '15px', fontWeight: isSmUp ? '700' : '600', 
                        color: theme.palette.primary.contrastText,
                        fontSize: isSmUp ? '14px' : '12px'}}
                        onClick={e => navigate("/predict/questions")}>
                          Questions&nbsp;<FontAwesomeIcon icon={faArrowRight} style={{display: isSmUp ? 'block' : 'none'}} />
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
 
              </Box>

              <Box sx={styles.dashbox} style={{margin: '30px 0px 30px 0px', padding: '0px 30px 30px 30px'}}>

              <Typography align='center' variant="h5" sx={{my: 3, mx: 2}}>Matches</Typography>

              {state.matches
              .filter((m) => m.stage === 'group')
              .sort((a,b) => (a.date > b.date) ? 1 : ((b.date > a.date) ? -1 : 0))
              .slice(0,4)
              .map((match, i) => (

                <Grid onClick={e => navigate('/match/' + match._id)}
                  container direction="row" justifyContent={"center"} alignItems="center" sx={{py:1.5, px: 2, 
                  backgroundColor: i % 2 ? theme.palette.grey[200] : theme.palette.grey[50],
                  borderRadius: i === 0 ? '10px 10px 0px 0px' : i === 3 ? '0px 0px 10px 10px' : '0px 0px 0px 0px',
                  cursor: 'pointer',
                  '&:hover': { backgroundColor: theme.palette.grey[300] }
                }} key={i}>
                  <Grid item lg={2} sx={{ display: {xs: 'none', lg: 'block' } }} 
                  /*sx={{ display: { xs: 'none', md: 'block'}, px: 2  }}*/>
                    <Typography variant="subtitle2" color="textSecondary">
                      {dayjs(match.date).format('D MMM')}
                    </Typography>
                  </Grid>
                  <Grid item xs={2} sm={1}>
                    <Avatar alt={getMatchDetails(state, match._id).homeTeam.name} src={getMatchDetails(state, match._id).homeTeam.flag} 
                    sx={{ width: 25, height: 25, marginRight: '10px' }} />
                  </Grid>
                  <Grid item xs={2} sm={4} lg={3}>
                    <Typography sx={{fontSize: isLgUp ? '14px' : '13px'}}
                    className="bold">{
                      isSmUp ? getMatchDetails(state, match._id).homeTeam.name :
                      getMatchDetails(state, match._id).homeTeam.country
                      }</Typography>
                  </Grid>
                  <Grid item xs={4} sm={2}>
                    <DisplayMatchScore matchid={match._id} variant={"dashboard"} />
                  </Grid>
                  <Grid item xs={2} sm={4} lg={3}>
                    <Box sx={{ textAlign:'right'}}>
                      <Typography sx={{fontSize: isLgUp ? '14px' : '13px'}}
                      className="bold">{
                        isSmUp ? getMatchDetails(state, match._id).awayTeam.name :
                        getMatchDetails(state, match._id).awayTeam.country
                        }</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={2} sm={1}>
                    <Box sx={{ textAlign:'right', marginLeft: '10px'}}>
                      <Avatar alt={getMatchDetails(state, match._id).awayTeam.name} src={getMatchDetails(state, match._id).awayTeam.flag} 
                      sx={{ width: 25, height: 25 }} />
                    </Box>
                  </Grid>
                </Grid>

              ))}

              {/*
              <Grid container direction="row" sx={{px: 3, pb:3}} justifyContent={"space-between"} alignItems="center">
                <Grid item xs={6}>
                  <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Selected League</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={state.league}
                    label="Selected League"
                    //onChange={handleChange}
                    sx={{backgroundColor: theme.palette.primary.contrastText}}
                  >
                  {state.leagues.map((l, i) => (
                    <MenuItem value={l._id} onClick={e => changeActiveLeague(l._id)}>
                      <Typography sx={{fontWeight: '400'}}>{l.name}</Typography>                      
                    </MenuItem>
                  ))}
                  </Select>
                </FormControl>
                </Grid>
                <Grid item>
                  <Grid container direction="column">
                    <Grid item>
                      <Button
                      onClick={e => navigate('/league/create/0')}
                      variant="text"
                      sx={{fontSize: '16px', fontWeight: '600', padding: '4px 30px'}}>
                        <FontAwesomeIcon icon={faUserEdit}/>&nbsp;&nbsp;Manage users
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                      onClick={e => navigate('/league/create/0')}
                      variant="text"
                      sx={{fontSize: '16px', fontWeight: '600', padding: '4px 30px'}}>
                        <FontAwesomeIcon icon={faPlusCircle} style={{marginRight: '3px'}}/>&nbsp;&nbsp;Create new league
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              */}
              </Box>
            </Grid>
            {Boolean(state.user) && 
            state.user.uid === 'hyPRV6TXakMbalAtyb33uDFsOJb2' ? // CP Answer Sheet
              <Grid item xs={12} md={6} container justifyContent="center" alignItems="center">
                <Box sx={styles.dashbox} style={{padding: '30px', marginBottom: isMdUp ? '30px' : '70px'}}>
                <Typography align='center' variant="h5">Execute Answer Sheet</Typography>

                <Grid container justifyContent="center" alignItems="center">
                  <Grid item sx={{my: 5}}>
                  {loading ?
                  <CircularProgressCP />
                  :
                  <>
                    {Boolean(reviewResponse) ?
                    <Box sx={{py: 2}}>
                      <Typography sx={{color: reviewResponse.success ? theme.palette.success.main : theme.palette.error.main}}>
                        {reviewResponse.msg}
                      </Typography>
                    </Box>
                    : ''}
                    <Button variant="contained" size="large" onClick={e => handleReviewAnswers()}>Review answers</Button>
                  </>
                  }
                  </Grid>
                </Grid>
                </Box>
              </Grid>
              :
              <Grid item xs={12} md={6} container justifyContent="center" alignItems="center">
                <Box sx={styles.dashbox} style={{padding: '30px', marginBottom: isMdUp ? '30px' : '70px'}}>
                <Typography align='center' variant="h5">Your Ranking</Typography>

                <RankedList isRankingScreen={false} />
                <LeagueManager />
                </Box>

              </Grid>
            }
          </Grid>
        </Grid>
        }

      </Box>

    </div>
  );
}

export default Dashboard;